<template>
  <div
    v-if="$route.query.isApp != 1"
    class="container-new-ui header-wrap-hut bg-white"
    :class="($route.name === 'category' || $route.name === 'combo-detail' || $route.name === 'coupons' || $route.name === 'topic' || $route.name === 'topic-detail') && 'fixed-header'">
    <!-- header main -->
    <div :class="['home', 'category', 'combo-detail'].includes($route.name) ? 'mycontainer' : ''">
      <ph-header
        :is-back="!['home', 'category', 'combo-detail'].includes($route.name)"
        :is-logo-center="!['home', 'category', 'combo-detail'].includes($route.name)"
        :title-back="$t('back')"
        height="60"
        class-name="bg-light"
        :class="!['home', 'category', 'combo-detail'].includes($route.name) && 'border-bottom'"
        :basket-info="basketInfo"
        :is-view-basket="$route.name === 'home'"
        externalStyle="background: white;"
        :is-disposition="(['category', 'combo-detail'].includes($route.name) && deliveryInfo.orderType) ? true : false"
        :disposition-mapping="dispositionObj"
        :is-asap="(['category', 'combo-detail'].includes($route.name) && deliveryInfo.orderType) ? true : false"
        :asap="asapObject"
        @btnPushBasket="viewMenu"
        @btnDisposition="actionDisposition"
        @btnAsap="showAsapPopup"
        @btnGoBack="goBack"
      >
        <template v-slot:customizeStore>
          <div
            v-if="storeCode"
            class="d-md-flex align-items-center asap-box cursor-pointer"
            @click.stop="gotoHutStore()"
          >
            <div class="cursor-pointer storeLink">
              <label
                class="order-type-text store-img border-b cursor-pointer mb-0"
              >
                <img
                  src="https://static.pizzahut.jp/jp/icons/store.png"
                  class="img-store"
                  alt="store"
                  width="17"
                  height="15"
                />
              </label>
              <strong>{{ storeName }}</strong>
            </div>
          </div>
        </template>
        <template v-slot:customizeUserLoggedIn>
          <dropdown-header></dropdown-header>
        </template>
      </ph-header>
    </div>
    <!-- header main -->

    <!-- banner main for login and sign up -->
    <div v-if="['register', 'login', 'free_side'].includes($route.name)">
      <ph-top-banner/>
      <div class="d-flex justify-content-center caps topic-header-banner" v-if="title">
        <span v-html="title"></span>
      </div>
    </div>

    <!-- banner title -->
    <h2
      v-else-if="!['home', 'category', 'combo-detail'].includes($route.name)"
      id="container-header-page"
      class="cond caps xs-text-center xs-py-35 xs-relative xs-my-0"
    >
      <span>
        <img src="https://static.pizzahut.jp/jp/icons/inactive.png" class="xs-mr-5" v-if="$route.meta.icon">
            <span v-if="$route.meta.key_title != 'postal_code' "
                  v-html="titleCustom || title"></span>
            <span v-else  class="group-postal-code">
             <img src="../../assets/images/icons/zipcode_black.png"/>
              <span class="pl-5 pr-5">{{convertPostalCode($route.params[$route.meta.key_params])}}</span>
            </span>
             <span v-if="$route.name != $const.REGISTRATION_CONFIRM
                && $route.name != $const.REGISTRATION_LIGHT_CONFIRM
                && $route.meta.key_title != 'postal_code'
                && $route.meta.key_params"
                   v-html="$route.params[$route.meta.key_params]">
             </span>
            <span class="sub-title t14"
                  v-if="$route.meta.sub_title"
                  v-html="$t($route.meta.sub_title)">
            </span>
      </span>
    </h2>
  </div>
</template>
<script>
import DropdownHeader from '@/components/popup/DropdownHeader'
import ASAPPopup from '@/components/popup/OrderASAP.vue'
import DispositionPopup from '../home/HomeLocalizationMapZipcodeNewDesign'
import * as types from '@/store/types'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment-timezone'
import { getExperiment } from '@pizza-hut/lib-experiments/lib'

export default {
  components: {DropdownHeader},
  computed: {
    ...mapGetters({
      hutReward: types.GET_HUT_REWARD,
      configTenant: types.GET_CONFIG_TENANT
    })
  },
  destroyed () {
    this.$root.$off('onReInitHeader')
    this.$root.$off('collectionTimeUpdate')
    this.$root.$off('cartUpdate')
  },
  updated () {
    this.title = this.$t(this.$route.meta.key_title)
  },
  created () {
    this.title = this.$t(this.$route.meta.key_title)
    this.basketInfo.title = this.$t('button_view_basket')
    this.getConfigTenant()
  },
  mounted () {
    this.$cart.init(this)
    this.initData()
    let vm = this
    this.$root.$on('cartUpdate', () => {
      vm.$cart.init(vm)
      vm.basketInfo.badges = vm.getTotalCartItem(vm.cart)
    })
    this.$root.$on('onReInitHeader', () => {
      vm.initData()
    })
    this.$root.$on('collectionTimeUpdate', () => {
      vm.updateWaitingTime()
    })
    this.$root.$on('onChangeMetaTitle', (data) => {
      vm.titleCustom = data
    })
    window.onbeforeunload = function() { 
      vm.goBack()
    };
  },
  data () {
    return {
      cartTotalItem: 0,
      basketInfo: {
        title: '',
        badges: 0
      },
      deliveryInfo: this.getDeliveryInfo(this),
      dispositionObj: {
        title: '',
        type: ''
      },
      asapObject: {
        title: ''
      },
      title: '',
      titleCustom: '',
      storeCode: '',
      storeName: ''
    }
  },
  methods: {
    ...mapActions({
      setHutReward: types.SET_HUT_REWARD,
      setMaintainanceHutReward: types.SET_MAINTAINANCE_HUT_REWARD,
      setExpiredDaysHutReward: types.SET_EXPIRED_DAYS_HUT_REWARD,
      setMaxItemHutReward: types.SET_MAX_ITEM_HUT_REWARD,
      setConfigTenant: types.SET_CONFIG_TENANT,
      setIsShowSimplifyHome: types.SET_IS_SHOW_SIMPLIFY_HOME,
      setExpiredHutRewardMode: types.SET_EXPIRED_HUT_REWARD_MODE,
      setDisplayPopupOrderConfirm: types.SET_DISPLAY_POPUP_ORDER_CONFIRM
    }),
    initData () {
      this.deliveryInfo = this.getDeliveryInfo(this)
      this.storeName = this.$disposition.getByKey(this, 'outletName', '')
      this.storeCode = this.$disposition.getByKey(this, 'outletCode', '')
      this.basketInfo.badges = this.getTotalCartItem(this.cart)
      if (this.deliveryInfo.orderType) {
        const type = this.deliveryInfo.orderType
        this.dispositionObj.title = type.toUpperCase() === this.$const.DELIVERY
          ? (this.$t('delivery_history') + ': ' + '<strong>' +  this.deliveryInfo.addressInfo + '</strong>')
          : (this.$t('carryout_from') + ': ')
        this.dispositionObj.type = type.toUpperCase()
      }
      this.updateWaitingTime()
      if (this.$auth.check()) {
        let vm = this
        this.axios.apiCustomer.getProfile((response) => {
          let user = response.data.data.item
          let cart = vm.$cart.get(vm)
          let currentPoint = vm.getValueFromAttr(user, 'point', 0)
          vm.setHutReward({
            point: cart.data.length === 0 ? currentPoint : (currentPoint - cart.hut_reward_used),
            rank: vm.getValueFromAttr(user, 'membership_id', 6),
            rankNextMonth: vm.getValueFromAttr(user, 'rank_next_month', 0),
            orderCountForNextRank: vm.getValueFromAttr(user, 'order_count_for_next_rank', 0),
            totalOrderCountForNextRank: vm.getValueFromAttr(user, 'total_order_count_for_next_rank', 0)
          })
        })
      }
    },
    goBack () {
      if (this.$route.name == 'payment-status' || this.$route.name == 'tracker-order') {
        this.$router.replace({name: 'home'})
      } else if (this.$route.name === 'checkout') {
        this.redirectToMenuPage()
      } else {
        this.$router.go(-1)
      }
    },
    showAsapPopup () {
      var vm = this
      if (vm.cartTotalItem === 0) {
        vm.$modal.show(ASAPPopup, {parentlink: vm.getCurrentPath()}, {class: ''})
      } else {
        vm.$modal.show('dialog', {
          text: vm.$t('confirm_change_order_time'),
          buttons: [
            {
              title: vm.$t('button_yes'),
              handler: () => {
                vm.$modal.hide('dialog')
                vm.$modal.show(ASAPPopup, {parentlink: vm.getCurrentPath()}, {class: ''})
              }
            },
            {
              title: vm.$t('button_close')
            }
          ]
        })
      }
    },
    convertPostalCode (data) {
      if (!data) {
        return ''
      }
      data = data.slice(0, 3) + '-' + data.slice(3)
      return data
    },
    updateWaitingTime () {
      if (this.$disposition.getByKey(this, 'advanceOrder', 0) === 0) {
        this.asapObject.title = this.$t('header.waiting_time', {min: this.getWaitingTime(this)})
      } else {
        this.asapObject.title = this.getTimePicker(this, true)
      }
    },
    showPopupDisposition () {
      const experiment = getExperiment('CVR', 'newDisposition')
      if (experiment === this.getValueExperiment('newDisposition', 'clickToOpenPopup')) {
        this.$modal.show(DispositionPopup, {isPopup: true}, {class: 'modal-localization'})
      } else {
        // this.$router.push({name: 'home'})
        this.$modal.show(DispositionPopup, {isPopup: true}, {class: 'modal-localization'})
      }
    },
    viewMenu () {
      this.$store.commit('setCategoryUuid', null)
      this.redirectToMenuPage()
      let vm = this
      if (this.isMobile()) {
        setTimeout(() => vm.$root.$emit('showHideCart', true), 1000)
      }
    },
    getConfigTenant () {
      let vm = this
      const params = {
        manual: 1
      }
      vm.axios.apiTenant.getConfigByClient(params, function (response) {
        vm.setConfigTenant(response.data.data.item)
        const today = moment.tz(new Date(), vm.$const.TIMEZONE).format('YYYY-MM-DD')
        const start = moment.utc(today + ' ' + vm.getValueFromAttr(response, 'data.data.item.start_time_sf'))
        const end = moment.utc(today + ' ' + vm.getValueFromAttr(response, 'data.data.item.end_time_sf'))
        const startTime = moment.tz(start, vm.$const.TIMEZONE)
        const endTime = moment.tz(end, vm.$const.TIMEZONE)
        const obj = {
          start_time: startTime.format('HH:mm:ss'),
          end_time: endTime.format('HH:mm:ss')
        }
        vm.setMaintainanceHutReward(obj)
        const expiredDays = vm.getValueFromAttr(response, 'data.data.item.reward_number_expired_days', 0)
        vm.setExpiredDaysHutReward(!isNaN(expiredDays) ? Number(expiredDays) : 0)
        const maxItemHutReward = vm.getValueFromAttr(response, 'data.data.item.maximum_quantity_redemption', 1)
        vm.setMaxItemHutReward(!isNaN(maxItemHutReward) ? Number(maxItemHutReward) : 1)
        const isShowSimplifyHome = vm.getValueFromAttr(response, 'data.data.item.simple_homepage', false)
        vm.setIsShowSimplifyHome((isShowSimplifyHome === 1 || isShowSimplifyHome === '1') || false)
        const defaultStoreCode = vm.getValueFromAttr(response, 'data.data.item.default_store_code', '')
        vm.$session.set('defaultStoreCode', defaultStoreCode)
        const expirationMaintenanceMode = vm.getValueFromAttr(response, 'data.data.item.hutreward_slice_expiration_maintenance_mode', 0)
        vm.setExpiredHutRewardMode(!isNaN(expirationMaintenanceMode) ? Number(expirationMaintenanceMode) : 0)
        const popupOrderConfirm = vm.getValueFromAttr(response, 'data.data.item.display_popup_order_confirm', 0)
        vm.setDisplayPopupOrderConfirm(!isNaN(popupOrderConfirm) ? Number(popupOrderConfirm) : 0)
        const minOnlinePayment = vm.getValueFromAttr(response, 'data.data.item.online_payment_threshold_in_yen', 0)
        vm.$session.set('minOnlinePayment', minOnlinePayment)
      })
    },
    actionDisposition () {
      if (this.isMobile()) {
        this.showAsapPopup()
      } else {
        this.showPopupDisposition()
      }
    },
    gotoHutStore () {
      this.$router.push({name: 'huts', params: {outlet: this.storeCode}})
    }
  }
}

</script>
<style scoped lang="scss">
  .order-datetime-title {
    background: black;
    span {
      padding-left: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/HeaderHutReward.vue